import { useCookies } from "react-cookie";

export default (styles?: any): { isClient: boolean, isCrawler: boolean, isClientClass: string } => {
    const [cookies] = useCookies(["HeydayHeadless"]);

    let isClient = false;
    let isCrawler = true;
    let isClientClass = undefined;

    const detectRobot = (userAgent: string): boolean => {
        const robots = new RegExp(([
            /bot/, /spider/, /crawl/,
            /APIs-Google/, /AdsBot/, /Googlebot/,
            /mediapartners/, /Google Favicon/,
            /FeedFetcher/, /Google-Read-Aloud/,
            /DuplexWeb-Google/, /googleweblight/,
            /bing/, /yandex/, /baidu/, /duckduck/, /yahoo/,
            /ecosia/, /ia_archiver/,
            /facebook/, /instagram/, /pinterest/, /reddit/,
            /slack/, /twitter/, /whatsapp/, /youtube/,
            /semrush/,
        ] as RegExp[]).map(r => r.source).join("|"), "i");

        return robots.test(userAgent);
    };

    if (typeof (cookies.HeydayHeadless) === "undefined" && !detectRobot(window?.navigator?.userAgent ?? "")) {
        isClient = true;
        isCrawler = false;
        isClientClass = styles ? styles.is_client : undefined;
    }

    return { isClient, isCrawler, isClientClass };
};